<template>
  <BaseTemplate :currentUser="currentUser">
    <Title eng="PACK LIST" :jpn="titleJpn" />
    <div class="product-list">
      <ProductBanner
        v-for="(packItem) in packList.list" :key="packItem.id"
        class="banner"
        :packItem="packItem"
        :currentUser="currentUser"
        @handleBannerClick="goToProductDetail"
        @handleLoginClick="goToLogin"
      />
    </div>
    <BoxPager
      v-if="packList &&
        packList.page.pages.length > 0
      "
      class="box-pager"
      :totalPageCount="packList.page.all_page"
      :currentPageCount="packList.page.page"
      :dispBoxCount="packList.page.pages.length"
      :pages="packList.page.pages"
      @handlePagerClick="changeCurrentPageCount"
      @handleSquareBtnClick="changeCurrentPageCount"
    />
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
// import {
//   separateCharacterNumber,
// } from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import t from '@/plugins/i18n';
// import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
// import CommonModal from '@/components/atoms/CommonModal.vue';
// import ProductBanner from '@/components/molecules/ProductBanner.vue';
// import ProductDescription from '@/components/molecules/ProductDescription.vue';
// import SquareButton from '@/components/atoms/SquareButton.vue';
// import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
// import SelectBox from '@/components/atoms/SelectBox.vue';
// import LeafBox from '@/components/organisms/LeafBox.vue';

export default {
  name: 'PackDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    ProductBanner,
    BoxPager,
    // CommonOverlay,
    // CommonModal,
    // ProductBanner,
    // ProductDescription,
    // SquareButton,
    // BlackGradationButton,
    // SelectBox,
    // LeafBox,
  },

  data: () => ({
    isOpenModal: false,
    errorMessageCount: null,
    count: 1,
    titleEng: '',
    titleJpn: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      packList: 'pack/packList',
      cardTypeList: 'cardType/cardTypeList',
    }),
  },

  watch: {
    cardTypeList(newList) {
      newList.forEach((row) => {
        if (row.id === this.$route.query.index) {
          this.titleJpn = this.t(row.name);
        }
      });
    },
  },

  created() {
    this.$store.dispatch('cardType/setCardTypeList');
    this.$store.dispatch('pack/setAllPackList', { pageNumber: 1, type: this.$route.query.index });
  },

  methods: {
    goToProductDetail(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
    },
    goToLogin() {
      this.$router.push({ path: '/' });
      this.$store.dispatch('user/setShowLoginPage', true);
    },
    changeCurrentPageCount(pageNumber) {
      const type = this.$route.query.index;
      this.$store.dispatch('pack/setAllPackList', { pageNumber, type });
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  .banner {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: $tabletWidth) {
  .product-list{
    .banner {
      min-width: 10vw;
      width: 44%;
    }
  }
}
</style>
